<template>
  <Chip :label="i18n(translations.chipTitle)" @click="openBackUpModal">
    <template #prefix>
      <RevIllustration
        :alt="i18n(translations.chipTitle)"
        :height="20"
        src="/img/product/jp/back_up_logo.svg"
        :width="20"
      />
    </template>
  </Chip>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'

import Chip from '~/scopes/product/components/Chip/Chip.vue'
import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'

import translations from './BackUpChip.translations'

const i18n = useI18n()
const { trackClick } = useTracking()
const openBackUpModal = () => {
  openModal(MODAL_NAMES.BACK_UP)
  trackClick({ zone: 'addon_service_pills', name: 'backup_chip' })
}
</script>
